import DocSetMenu from "../../../../src/components/docset-menu.js";
import DocSet from "../../../../src/components/doc-set.js";
import * as React from 'react';
export default {
  DocSetMenu,
  DocSet,
  React
};